import { getCookie, setCookie } from "@/libraries/VueMethods";
import { uniqueId } from "@/libraries/VueMethods";
import cloneDeep from "lodash/cloneDeep";
import clone from "lodash/clone";

/**
 * @property {[{
 *   id: Number,
 *   price: Number,
 *   quantity: Number,
 *   discount_price: Number,
 *   variety_id: Number,
 * }]} cartItems
 */
export default class cart {
  // Dont add app to properties, it causes recursion error
  constructor(app, initialCarts = [], mode = null) {
    const homeData = app.$store.getters["front/getHomeData"];
    if (mode == "server" || homeData.user.login) {
      this.mode = "server";
      this.cartItems = initialCarts;
    } else {
      this.mode = "cookie";
      this.cartItems = initialCarts;
    }
  }

  async addToCart(cartItem) {
    let flag = false;

    this.cartItems.forEach((item) => {
      if (item.id == cartItem.id) {
        item.quantity = cartItem.quantity;
        // item.max_limit_for_front = cartItem.max_limit_for_front;
        item.price = cartItem.price;
        item.discount_price = cartItem.discount_price;
        flag = true;
      }
    });
    if (!flag) {
      this.cartItems.push(cartItem);
    }
  }

  deleteCart(cartItem) {
    this.cartItems = this.cartItems.filter((_cartItem) => {
      return _cartItem.id != cartItem.id;
    });

    this.updateCookieIfNeeded();
  }

  /**
   * @return {[{
   *   max_limit_for_front: Number,
   *   vId: String,
   *   q: Number,
   *   price: Number,
   *   d_price: Number
   * }]}
   */
  static getVarietyIdsFromCookie() {
    let fromCookie = null;
    try {
      fromCookie = JSON.parse(getCookie("cart"));
    } catch (error) {
      fromCookie = [];
      console.log("error fromCookie");
    } finally {
      return fromCookie ? fromCookie : [];
    }
  }

  addFakeChart(variety, quantity, product) {
    if (variety.quantity == 0) {
      throw new Error("NO_STOCK");
    }
    let component = product.component;
    product.component = null;
    variety.product = cloneDeep(product);
    product.component = component;

    let flag = false;
    this.cartItems.forEach((item) => {
      // isNan checks if cart item is fake
      if (isNaN(item.id) && item.variety.id == variety.id) {
        let newQuantity = item.quantity + quantity;
        if (newQuantity > variety.quantity) {
          throw new Error("NO_STOCK");
        }
        item.quantity = newQuantity;
        flag = true;
      }
    });

    if (!flag) {
      this.cartItems.push(cart.makeFakeCart(variety, quantity));
    }
  }

  /**
   * To save in cookie
   */
  static makeFakeCart(variety, quantity) {
    return {
      id: uniqueId(), // Random Id
      // max_limit_for_front: variety.max_limit_for_front,
      variety_id: variety.id,
      quantity: variety.quantity < quantity ? variety.quantity : quantity,
      price: variety.final_price.amount,
      discount_price: variety.final_price.discount_price,
      variety,
    };
  }

  setCartQuantity(cartItem, newQuantity) {
    this.cartItems = this.cartItems.map((_cartItem) => {
      if (cartItem.id == _cartItem.id) {
        _cartItem.quantity = newQuantity;
      }

      return _cartItem;
    });
    this.updateCookieIfNeeded();
  }

  getTotalSaving(excloudedCartIds = []) {
    return this.cartItems.reduce((sum, item) => {
      if (excloudedCartIds.includes(item.id)) {
        return sum;
      }
      sum +=
        item.discount_price != null ? item.discount_price * item.quantity : 0;
      return sum;
    }, 0);
  }

  getTotalPrice(excludedCartIds = []) {
    return this.cartItems.reduce((sum, item) => {
      if (excludedCartIds.includes(item.id)) {
        return sum;
      }
      sum += item.price * item.quantity;
      return sum;
    }, 0);
  }

  getTotalWeight(excludedCartIds = [], settingWeight) {
    return this.cartItems.reduce((sum, item) => {
      if (excludedCartIds.includes(item.id)) {
        return sum;
      }
      let weight = 0;
      if (item.variety.weight) {
        weight = item.variety.weight;
      } else if (item.variety.product.weight) {
        weight = item.variety.product.weight;
      } else {
        weight = settingWeight;
      }

      sum += weight * item.quantity;
      return sum;
    }, 0);
  }
  // Check if variety already exists
  hasVariety(varietyId) {
    varietyId =
      varietyId && typeof varietyId === "object" ? varietyId.id : varietyId;
    return this.cartItems.find((cartItem) => {
      return cartItem.variety_id == varietyId;
    });
  }
  emptyCookie() {
    this.cartItems = [];
    this.mode = "cookie";
    setCookie("cart", JSON.stringify([]));
  }
  // updateCookieIfNeeded() {
  //   if (this.mode === "cookie" && this.cartItems) {
  //     setCookie(
  //       "cart",
  //       JSON.stringify(
  //         this.cartItems.map((cartItem) => {
  //           return {
  //             max_limit_for_front: cartItem.variety.max_limit_for_front,
  //             vId: cartItem.variety.id,
  //             q: cartItem.quantity,
  //             price: cartItem.price,
  //             d_price: cartItem.discount_price, // felan niaz nist mahze etminan
  //           };
  //         }),
  //       ),
  //       365,
  //     );
  //   }
  // }

  updateCookieIfNeeded() {
    if (this.mode === "cookie" && this.cartItems) {
      // مجموع قیمت محصولاتی که min_cart ندارن (یا صفره) - قیمت × تعداد
      const freeItemsTotal = this.cartItems
        .filter((item) => !item.variety.min_cart || item.variety.min_cart == 0)
        .reduce((sum, item) => sum + item.price * item.quantity, 0);

      // آیتم‌هایی که باید حذف بشن رو جدا نگه می‌داریم
      const removedItems = this.cartItems.filter((item) => {
        return (
          item.variety.min_cart &&
          item.variety.min_cart > 0 &&
          freeItemsTotal < item.variety.min_cart
        );
      });

      // حذف محصولاتی که min_cart دارن ولی مجموع بالا بهش نمی‌رسه
      this.cartItems = this.cartItems.filter((item) => {
        if (item.variety.min_cart && item.variety.min_cart > 0) {
          return freeItemsTotal >= item.variety.min_cart;
        }
        return true; // بقیه محصولات دست‌نخورده می‌مونن
      });

      // نمایش پیام برای هر محصول حذف‌شده
      removedItems.forEach((item) => {
        alert(
          `محصول ${
            item.variety.product.title
          } به دلیل نرسیدن به حداقل مبلغ ${Number(
            item.variety.min_cart,
          ).toLocaleString("fa-IR")} سبد خرید حذف شد`,
        );
      });

      setCookie(
        "cart",
        JSON.stringify(
          this.cartItems.map((cartItem) => {
            return {
              max_limit_for_front: cartItem.variety.max_limit_for_front,
              vId: cartItem.variety.id,
              q: cartItem.quantity,
              price: cartItem.price,
              d_price: cartItem.discount_price,
            };
          }),
        ),
        365,
      );
    }
  }

  // اون کویری استرینگی که قراره درخواست بزنیم و میسازه
  static getCartRequestQueryString() {
    let fromCookie = cart.getVarietyIdsFromCookie();

    let varietyIds = [];
    let prices = [];
    let quantities = [];
    fromCookie.forEach((item) => {
      varietyIds.push(item.vId);
      prices.push(item.price);
      quantities.push(item.q);
    });

    return {
      variety_ids: varietyIds.join(","),
      prices: prices.join(","),
      quantities: quantities.join(","),
    };
  }

  // بعد اینکه تنوع هارو از درخواست گرفتیم حالا پرش میکنیم
  static getInitialCartForCookieMode(cartRequest) {
    let varieties = cartRequest.varieties;
    let warnings = cartRequest.warnings;
    let fromCookie = cart.getVarietyIdsFromCookie();
    let cartItems = [];

    varieties.forEach((varietyFromRequest) => {
      let quantity = fromCookie.find((fC, index) => {
        return fC.vId == varietyFromRequest.id;
      });
      quantity = quantity.q;

      // اگر موجودی محصول از سبد خرید کمتر بود این متد هندل میکنه
      cartItems.push(cart.makeFakeCart(varietyFromRequest, quantity));
    });

    cart.showWarnings(warnings, cartItems, "cookie");

    return cartItems;
  }

  // نمایش وارنینگ ها به مشتری با نوتیفیکیشن
  static showWarnings(warnings, cartItems, mode) {
    // اگر مود سرور باشه باید با آیدی مطابقت بدیم
    //اگر مود کوکی باشه با ایندکس
    if (mode == "cookie") {
      warnings.forEach((warning) => {
        let cartItem = cartItems[warning.cart_id];
        if (cartItem) {
          // نمایش ارور به کاربر
          // بنابه دلایلی نمیشه از نووتیفای استفاده کرد ارور میده
          alert(cart.getWarningMessages(warning, cartItem));
        }
      });
    }
  }

  static getWarningMessages(warning, cartItem) {
    // کانفیگ پیام ها
    const messages = {
      diffLower: [
        " توجه: از تعداد محصول ",
        " در انبار ما و سبد خرید شما کم شد ",
      ],
      diffPrice: ["توجه: قیمت محصول ", "تومان افزایش یافت", "تومان کاهش یافت"],
      unavailable: ["محصول ", " تمام شده و دیگر در سبد خرید شما موجود نیست"],
    };
    switch (warning.type) {
      case "quantity":
        return (
          messages.diffLower[0] +
          cartItem.variety.product.title +
          messages.diffLower[1]
        );
      case "price":
        return (
          messages.diffPrice[0] +
          cartItem.variety.product.title +
          " " +
          Math.abs(warning.diff_price) +
          (warning.diff_price > 0
            ? messages.diffPrice[1]
            : messages.diffPrice[2])
        );
      case "unavailable":
        return (
          messages.unavailable[0] +
          cartItem.variety.product.title +
          messages.unavailable[1]
        );
    }
  }
}
